import { createSlice } from "@reduxjs/toolkit"
import {
    addBrand,
    allBrandNoPagination,
    getActiveBrand,
    getAllBrand,
    getAllBrandCount,
    getBrand,
    getInActiveBrand,
    toggleBrandStatus,
    updateBrand
} from "../actions/brand";

const INITIAL_STATE = {
    isLoading: false,
    isError: false,
    allBrandList: [],
    brandListNoPagination: [],
    singleBrand: null,
    allBrandCount: 0,
    inActiveBrand: 0,
    activeBrand: 0,
    total: 0,
}

export const brandSlice = createSlice({
    name: "brand",
    initialState: INITIAL_STATE,
    extraReducers: (builder) => {
        builder.addCase(addBrand.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(addBrand.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(addBrand.rejected, (state) => {
            state.isError = true;
        });

        //=================================
        // Get all brand with pagination
        //=================================
        builder.addCase(getAllBrand.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllBrand.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allBrandList = action.payload.data?.data;
            state.total = action.payload.data?.total
        });
        builder.addCase(getAllBrand.rejected, (state) => {
            state.isError = true;
        });

        //=================================
        // Get all brand without pagination
        //=================================
        builder.addCase(allBrandNoPagination.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(allBrandNoPagination.fulfilled, (state, action) => {
            state.isLoading = false;
            state.brandListNoPagination = action.payload.data?.brand;
        });
        builder.addCase(allBrandNoPagination.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get single brand
        //===========================
        builder.addCase(getBrand.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getBrand.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleBrand = action.payload.data?.brand;
        });
        builder.addCase(getBrand.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get all brand count
        //===========================
        builder.addCase(getAllBrandCount.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllBrandCount.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allBrandCount = action.payload.data?.brand;
        });
        builder.addCase(getAllBrandCount.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get inActive brand
        //===========================
        builder.addCase(getInActiveBrand.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getInActiveBrand.fulfilled, (state, action) => {
            state.isLoading = false;
            state.inActiveBrand = action.payload.data?.inActiveBrand;
        });
        builder.addCase(getInActiveBrand.rejected, (state) => {
            state.isError = true;
        });


        //===========================
        //Get active brand
        //===========================
        builder.addCase(getActiveBrand.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getActiveBrand.fulfilled, (state, action) => {
            state.isLoading = false;
            state.activeBrand = action.payload.data?.activeBrand;
        });
        builder.addCase(getActiveBrand.rejected, (state) => {
            state.isError = true;
        });

        //============================
        // toggle brand status
        //============================
        builder.addCase(toggleBrandStatus.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(toggleBrandStatus.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(toggleBrandStatus.rejected, (state) => {
            state.isError = true;
        });

        //==============================
        //update brand
        //=============================
        builder.addCase(updateBrand.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateBrand.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(updateBrand.rejected, (state) => {
            state.isError = true;
        });
    }
})

export default brandSlice.reducer;